/* eslint-disable camelcase */
import { SORT_ORDER, TFilterOptions } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { CUSTOM_FIELDS_FILTER_PARAM_KEY } from 'src/apps/dashboard/constants/CustomFields';
import { buildEnvironmentFilters } from 'src/apps/dashboard/services/queries/dashboard/helpers/environmentFilterBuilder';
import { IGetWebSdkTestsParams } from 'src/apps/dashboard/types/WebSdkDashboardServiceTypes';
import { ENVIRONMENT_LABEL_KEY } from 'src/common/consts/platformConfigConsts';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	ConditionOperators,
	Wsdk_Test_RunsSortFields,
	Wsdk_Test_RunsSortOrder
} from 'src/common/types/graphql.generated';

import { DashboardWebSdkTestsQueryVariables } from '../Tests.generated';

const DAYS_AMOUNT_FILTER_PARAM_KEY = 'daysAmountFilter';

const testsSortFieldNamesMap: Record<string, Wsdk_Test_RunsSortFields> = {
	testName: Wsdk_Test_RunsSortFields.TestName,
	runTime: Wsdk_Test_RunsSortFields.RunTime,
	criticalIssues: Wsdk_Test_RunsSortFields.CriticalIssues,
	seriousIssues: Wsdk_Test_RunsSortFields.SeriousIssues,
	totalIssues: Wsdk_Test_RunsSortFields.TotalIssues,
	testPath: Wsdk_Test_RunsSortFields.TestPath,
	testDisplayName: Wsdk_Test_RunsSortFields.TestName
};

const testsSortOrderMap: Record<SORT_ORDER, Wsdk_Test_RunsSortOrder> = {
	[SORT_ORDER.ASC]: Wsdk_Test_RunsSortOrder.Ascending,
	[SORT_ORDER.DESC]: Wsdk_Test_RunsSortOrder.Descending
};

export const buildTestsQueryVariables = ({
	dateRange,
	pageSize,
	page,
	filterOptions,
	sort,
	isShowTestPath,
	labelsExcludedFromDashboard
}: IGetWebSdkTestsParams): DashboardWebSdkTestsQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<DashboardWebSdkTestsQueryVariables>({
		sortFieldsMap: testsSortFieldNamesMap,
		sortOrderMap: testsSortOrderMap
	});

	let sortFields;
	if (sort?.dataField === 'testDisplayName') {
		sortFields = isShowTestPath ? ['testPath', 'testName'] : ['testName'];
	}

	variablesBuilder.addPaginationParams(page, pageSize).addSortParam(sort, sortFields);

	const customFieldOptions = omit(filterOptions ?? {}, [ENVIRONMENT_LABEL_KEY]) as TFilterOptions;

	variablesBuilder.addTupleFilterParam(
		CUSTOM_FIELDS_FILTER_PARAM_KEY,
		customFieldOptions,
		ConditionOperators.All
	);

	variablesBuilder.addConditionParam(DAYS_AMOUNT_FILTER_PARAM_KEY, dateRange);

	if (labelsExcludedFromDashboard && Object.keys(labelsExcludedFromDashboard).length > 0) {
		variablesBuilder.addNeTupleFilterParam(
			'customFieldsFilterExcludes' as keyof DashboardWebSdkTestsQueryVariables,
			labelsExcludedFromDashboard
		);
	}

	const variables = variablesBuilder.getVariables();
	const environmentConfig = buildEnvironmentFilters(filterOptions as IFilterOptions);

	return {
		...variables,
		...(environmentConfig?.customFieldsFilter && {
			environmentCustomFieldsFilter: environmentConfig.customFieldsFilter
		}),
		...(environmentConfig?.environmentsFilter && {
			environmentsFilter: environmentConfig.environmentsFilter
		})
	};
};
